import {styled} from "@mui/material/styles"
import {Badge} from "@mui/material"

export const FavouritesBadge = styled(Badge)(({theme}) => ({
    '[class*="MuiBadge-badge"]': {
        background: theme.uxfabric.components.badge.notification.backgroundColor,
        zIndex: 0,
    },
    justifyContent: "center",
    alignContent: "center",
}))
